import { Fattura } from '../../../models/fattura';

export class FatturaAdapter {
  fattura: Fattura = new Fattura();
  constructor(fattura: Fattura) {
    this.fattura.id = fattura.id ;
    this.fattura.altraParte = fattura.altraParte  ?  JSON.parse(JSON.stringify(fattura.altraParte)) : null;
    this.fattura.dataEmissione = fattura.dataEmissione ;
    this.fattura.numeroFattura = fattura.numeroFattura ;
    this.fattura.numeroGiorniPagamento = fattura.numeroGiorniPagamento ;
    this.fattura.totaleImportoAttivita = fattura.totaleImportoAttivita ;
    this.fattura.speseEsenti = fattura.speseEsenti ;
    this.fattura.speseImponibili = fattura.speseImponibili ;
    this.fattura.iva = fattura.iva ?  JSON.parse(JSON.stringify(fattura.iva)) : null;
    this.fattura.flagIva = fattura.flagIva ? fattura.flagIva : false;
    this.fattura.flagContributoPrevidenziale = fattura.flagContributoPrevidenziale ? fattura.flagContributoPrevidenziale : false;
    this.fattura.descrizioneContributoPrevidenziale = fattura.descrizioneContributoPrevidenziale ;
    this.fattura.percentualeContributoPrevidenziale = fattura.percentualeContributoPrevidenziale ;
    this.fattura.flagAltreSpese = fattura.flagAltreSpese ? fattura.flagAltreSpese : false;
    this.fattura.descrizioneAltreSpese = fattura.descrizioneAltreSpese ;
    this.fattura.percentualeAltreSpese = fattura.percentualeAltreSpese ;
    this.fattura.flagRitenutaAcconto = fattura.flagRitenutaAcconto ? fattura.flagRitenutaAcconto : false;
    this.fattura.attivitaFatture = fattura.attivitaFatture  ?  JSON.parse(JSON.stringify(fattura.attivitaFatture)) : [];
    this.fattura.note = fattura.note ;
    this.fattura.documenti = fattura.documenti  ?  JSON.parse(JSON.stringify(fattura.documenti)) : null;
  };
}
